export default __webpack_public_path__ + "static/media/3.1f8dca25.jpg";